// 计算窗口大小
export function getScreenSize() {
  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  return {
    height,
    width,
  };
}

// 计算距离文档左偏移
export function getElementLeft(element) {
  let actualLeft = element.offsetLeft;
  let current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
}

// 计算距离文档上偏移
export function getElementTop(element) {
  let actualTop = element.offsetTop;
  let current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}

// 计算距离文档上滚动偏移
export function getScrollTop() {
  let scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  return scrollTop;
}

// canvas尺寸重置
export function canvasResize(canvasEl, canvasCtx, width, height) {
  let copyEl = document.createElement('canvas');
  copyEl.width = canvasEl.width;
  copyEl.height = canvasEl.height;
  copyEl.getContext('2d').drawImage(canvasEl, 0, 0);

  if (width !== undefined) {
    canvasEl.width = width;
  }
  if (height !== undefined) {
    canvasEl.height = height;
  }
  canvasCtx.drawImage(copyEl, 0, 0);
}